import { UserRound } from "lucide-react";
import { cn } from "@/lib/utils";

type LeadAssignedMemberLabelProps = {
  memberName: string;
  className?: string;
};

/** Nomes dos membros atribuídos ao lead — visível para toda a equipe no kanban. */
export function LeadAssignedMemberLabel({ memberName, className }: LeadAssignedMemberLabelProps) {
  const names = memberName.split(",").map((name) => name.trim()).filter(Boolean);
  const title =
    names.length > 1
      ? `Atribuído a ${names.join(", ")}`
      : `Atribuído a ${memberName}`;

  return (
    <p
      className={cn(
        "mb-1.5 flex items-center gap-1 truncate text-[10px] leading-tight text-muted-foreground",
        className,
      )}
      title={title}
    >
      <UserRound className="h-2.5 w-2.5 shrink-0 text-primary" strokeWidth={2} aria-hidden />
      <span className="truncate font-medium text-primary">{memberName}</span>
    </p>
  );
}
